import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeRecord } from '@/domain/entities/judge/judgeRecord'
import { RecentJudgeListModuleName } from '@/store/modules/modules'

export class RecentJudgeListViewModel {
  private store = useStore()

  recentJudgeList: ComputedRef<JudgeRecord[]> = computed(
    () => this.store.getters[`${RecentJudgeListModuleName}/recentJudgeList`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${RecentJudgeListModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${RecentJudgeListModuleName}/error`])

  async getRecentJudgeResultList(): Promise<void> {
    await this.store.dispatch(`${RecentJudgeListModuleName}/getRecentJudgeResultList`)
  }
}
